<template>
  <div v-loading.fullscreen="loading">
    <div class="header-scroll">
      <div class="header">
        <el-input
          v-model="search"
          placeholder="Fraksiya nomi bo'yicha qidirish"
          clearable
          class="header-control"
          @input="onSearch"
          @clear="onSearch"
        />

        <el-button
          class="header-button header-button--right"
          type="primary"
          @click="openCreateDialog"
        >
          Qo'shish
        </el-button>
      </div>
    </div>

    <el-table :data="fractions" border height="calc(100vh - 270px)">
      <el-table-column type="index" :index="indexMethod" width="60" />
      <el-table-column prop="title" label="Nomi" min-width="240" />
      <el-table-column prop="created_at" label="Yaratilgan vaqti" min-width="170">
        <template #default="scope">
          {{
            scope.row.created_at
              ? $moment(scope.row.created_at).format("DD-MM-YYYY / HH:mm")
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column prop="updated_at" label="Yangilangan vaqti" min-width="170">
        <template #default="scope">
          {{
            scope.row.updated_at
              ? $moment(scope.row.updated_at).format("DD-MM-YYYY / HH:mm")
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column width="180" label="Amallar" fixed="right">
        <template #default="scope">
          <div class="action-grid">
            <el-button
              size="small"
              type="primary"
              @click="openEditDialog(scope.row)"
            >
              Tahrirlash
            </el-button>
            <el-button
              size="small"
              type="danger"
              @click="onDelete(scope.row)"
            >
              O'chirish
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <div>Fraksiyalar soni: {{ totalCount }}</div>
      <el-pagination
        background
        layout="sizes, prev, pager, next"
        :total="totalCount"
        v-model:page-size="limit"
        v-model:current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      v-model="showDialog"
      :title="form.id ? 'Fraksiyani tahrirlash' : 'Fraksiya qo\'shish'"
      width="500px"
      @closed="resetForm"
    >
      <el-form ref="formRef" :model="form" label-position="top">
        <el-form-item label="Nomi (o'zbekcha, lotin)">
          <el-input
            v-model="form.title_lang.uz_lat"
            placeholder="O'zbekcha (lotin) nomi"
            size="large"
          />
        </el-form-item>

        <el-form-item label="Nomi (ўзбекча, кирилл)">
          <el-input
            v-model="form.title_lang.uz_cyr"
            placeholder="Ўзбекча (кирилл) номи"
            size="large"
          />
        </el-form-item>

        <el-form-item label="Nomi (русский)">
          <el-input
            v-model="form.title_lang.ru"
            placeholder="Русское название"
            size="large"
          />
        </el-form-item>

        <el-form-item label="Nomi (english)">
          <el-input
            v-model="form.title_lang.en"
            placeholder="English title"
            size="large"
          />
        </el-form-item>

        <el-form-item label="Nomi (qaraqalpaqsha)">
          <el-input
            v-model="form.title_lang.kr"
            placeholder="Qaraqalpaqsha atı"
            size="large"
          />
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showDialog = false">Bekor qilish</el-button>
          <el-button type="primary" @click="onSubmit">Saqlash</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";

export default {
  name: "FractionList",
  data() {
    return {
      loading: false,
      fractions: [],
      totalCount: 0,
      limit: 20,
      currentPage: 1,
      search: "",
      searchTimer: null,
      showDialog: false,
      form: {
        id: null,
        title_lang: { uz_lat: "", uz_cyr: "", ru: "", en: "", kr: "" },
      },
    };
  },
  methods: {
    indexMethod(index) {
      return this.limit * (this.currentPage - 1) + index + 1;
    },
    getFractions() {
      this.loading = true;
      this.$http
        .get("api/v1/deputyv2/fractions", {
          params: {
            search: this.search || null,
            limit: this.limit,
            offset: this.limit * (this.currentPage - 1),
          },
        })
        .then(({ data }) => {
          this.fractions = data.fractions || [];
          this.totalCount = data.count || 0;
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response?.data?.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1;
        this.getFractions();
      }, 400);
    },
    openCreateDialog() {
      this.resetForm();
      this.showDialog = true;
    },
    openEditDialog(row) {
      this.form = {
        id: row.id,
        title_lang: {
          uz_lat: row.title_lang?.uz_lat || "",
          uz_cyr: row.title_lang?.uz_cyr || "",
          ru: row.title_lang?.ru || "",
          en: row.title_lang?.en || "",
          kr: row.title_lang?.kr || "",
        },
      };
      this.showDialog = true;
    },
    resetForm() {
      this.form = {
        id: null,
        title_lang: { uz_lat: "", uz_cyr: "", ru: "", en: "", kr: "" },
      };
      this.$refs.formRef?.clearValidate();
    },
    buildPayload() {
      const titleLang = {};
      ["uz_lat", "uz_cyr", "ru", "en", "kr"].forEach((key) => {
        if (this.form.title_lang[key]?.trim()) {
          titleLang[key] = this.form.title_lang[key].trim();
        }
      });
      return { title_lang: titleLang };
    },
    onSubmit() {
      const payload = this.buildPayload();
      if (!Object.keys(payload.title_lang).length) {
        ElMessage({
          type: "warning",
          message: "Kamida bitta tilda nomini kiriting",
        });
        return;
      }

      this.loading = true;
      const request = this.form.id
        ? this.$http.put(`api/v1/deputyv2/fractions/${this.form.id}`, payload)
        : this.$http.post("api/v1/deputyv2/fractions", payload);

      request
        .then(() => {
          ElNotification({
            title: "Tabriklaymiz",
            message: "Muvaffaqiyatli saqlandi",
            type: "success",
          });
          this.showDialog = false;
          this.getFractions();
        })
        .catch(({ response }) => {
          ElNotification({
            title: "Xatolik",
            message: response?.data?.message || "Iltimos, qayta urinib ko'ring.",
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onDelete(row) {
      ElMessageBox.confirm(
        `"${row.title}" fraksiyasini o'chirasizmi?`,
        "Diqqat!",
        {
          confirmButtonText: "Ha",
          cancelButtonText: "Bekor qilish",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`api/v1/deputyv2/fractions/${row.id}`)
            .then(() => {
              ElMessage({ type: "success", message: "Fraksiya o'chirildi" });
              if (this.fractions.length === 1 && this.currentPage > 1) {
                this.currentPage -= 1;
              }
              this.getFractions();
            })
            .catch(({ response }) => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: response?.data?.message || "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({ type: "info", message: "O'chirish bekor qilindi" });
        });
    },
    handleCurrentChange() {
      this.getFractions();
    },
    handleSizeChange() {
      this.currentPage = 1;
      this.getFractions();
    },
  },
  mounted() {
    this.getFractions();
  },
};
</script>

<style scoped>
.header-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 10px;
}

.header {
  display: flex;
  gap: 10px;
  align-items: center;
}

.header-control {
  width: 280px;
  flex-shrink: 0;
}

.header-button {
  flex-shrink: 0;
}

.header-button--right {
  margin-left: auto;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.action-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.action-grid :deep(.el-button) {
  margin: 0;
  width: 100%;
}
</style>
